import moment from 'moment'
import firebase from 'firebase/app';
import 'firebase/firestore';
import XLSX from 'xlsx';
import store from "../store";
const crypto = require("crypto");
export { NotificationManager} from 'react-notifications';
export { translate,Trans} from 'react-i18next';
const TR_ARRAY = [];
for (let i = 0; i < 24; i++) {
    TR_ARRAY.push(i + 1);
}

export const version = '1.1.0.5';
const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqEWpyDFYdK4Sssr+wTK9
NHFh6RwxIFq/WJn/rIbOVU0aXZyM/sAI147HQrQxePZBMYyG1lbDmueUewlVRckb
8anbAQ3UllkGW3UECJAXlCLkaHH7fBqfuN16FHG2sbegMrLzt40s/Z3SrJEBkrXI
Yz67LPtmy0NlTtuUrSfhv3PB4e7Q6jbYV3kolznYmsEyE2uTu/tZxg0XkhSLMZs0
IOtyX64BpDUUq2guErQ02NS46LqEKRvlAQU4m/V26y8m5FbpoyNlo0LciO3UkM9r
jFkmb8Fq73Jdp5P9qYs3FrzAcGd820gG+vI7a0eq/wMeoiugz8E6oS54FjVE3jaE
1wIDAQAB
-----END PUBLIC KEY-----`;
export const encryptStringWithRsaPublicKey = (toEncrypt) => {
    const buffer = new Buffer(toEncrypt);
    const encrypted = crypto.publicEncrypt(publicKey, buffer);
    return encrypted.toString("base64");
};
export async function checkVersion(){

  let doc =  await firebase.firestore().collection("settings").doc("version").get();
  let checked = false;
  let v= version;
  if(doc.exists)
  {
    let data = doc.data();
    if(data.web <= version)
    {
      checked = true;
    }
    else {
      v = data.web;
    }
  }
  return checked?true:v;
}
export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validatePhone (phone){
  var re = /^(0)+([1-9])+([0-9]{8,9})$/;
    return re.test(phone);
};
export function getBusinessDays(endDate, startDate) {
    var lastDay = moment(endDate);
    var firstDay = moment(startDate);
    let calcBusinessDays = 0 + (lastDay.diff(firstDay, 'days') * 6 -
      (firstDay.day() - lastDay.day()) * 1) / 7;

    //if (lastDay.day() == 6) calcBusinessDays--;//SAT
    if (firstDay.day() == 0) calcBusinessDays--;//SUN

    return calcBusinessDays;
  }
  export function checkTodate(items,fd,td,week)
  {
    let fromdate  = fd.clone();
    let todate2 = td.clone();
    let holiday = 0;
    let todate = todate2.clone();

    for(let hItem of items)
    {


      //console.log(todate.format("LL"),hItem);
      if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')||moment(hItem.todate).isBetween(fromdate,todate,'day','[]')||(fromdate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]')&&todate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]')))
      {

        let tHoliday = 0;
        if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')&&moment(hItem.todate).isBetween(fromdate,todate,'day','[]'))
        {
        //  console.log('t1');
          tHoliday = moment(hItem.todate).diff(moment(hItem.fromdate),"days");

        }
        else if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]'))
        {
        //  console.log('t2');
          tHoliday = moment(hItem.todate).diff(moment(hItem.fromdate),"days");

        }
        else if(moment(hItem.todate).isBetween(fromdate,todate,'day','[]')) {
        //  console.log('t3');
          tHoliday = moment(hItem.todate).diff(fromdate, 'days');

        }
        else {
        //  console.log('t4');
          fromdate = moment(hItem.todate);
          todate2 = fromdate.clone().add(week*7,"days");

          holiday = 0;
        }
        //console.log(tHoliday);
        holiday+=tHoliday;
      }
      todate = todate2.clone().add(holiday,"days");
    }
    //console.log(todate.format("LL"));


    return {fromdate,todate};
  }
export function pad2(number){
  return (number<10?'0':'')+number;
}
export function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
export function addSuff(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}
export function PERS(ACCOUNT) {
  let PERS = {};
  if(ACCOUNT&&ACCOUNT.permissions)
  {
    PERS = ACCOUNT.permissions;
  }
  else if(ACCOUNT) {

    let permissions = {};
    if(ACCOUNT.type==1)
    {
      permissions.class = true;
      permissions.practice = true;
      permissions.lesson = true;
      permissions.challenge = false;
    }
    else if(ACCOUNT.type==0)
    {
      if(ACCOUNT.idkhoahoc)
      {
        permissions.class = false;
        permissions.practice = true;
        permissions.lesson = true;
        permissions.challenge = true;
      }
      else {
        permissions.class = false;
        permissions.practice = true;
        permissions.lesson = false;
        permissions.challenge = false;
      }

    }
    PERS = permissions;
}
  return PERS;
}

export const HOURS = [{ value: "08", name: "8 AM" }, { value: "09", name: "9 AM" }, { value: "10", name: "10 AM" }, { value: "11", name: "11 AM" }, { value: "12", name: "12 PM" }, { value: "13", name: "1 PM" }, { value: "14", name: "2 PM" }, { value: "15", name: "3 PM" }, { value: "16", name: "4 PM" }, { value: "17", name: "5 PM" }, { value: "18", name: "6 PM" }, { value: "19", name: "7 PM" }, { value: "20", name: "8 PM" }, { value: "21", name: "9 PM" }, { value: "22", name: "10 PM" }, { value: "23", name: "11 PM" }, { value: "00", name: "12 AM" }, { value: "01", name: "1 AM" }, { value: "02", name: "2 AM" }, { value: "03", name: "3 AM" }, { value: "04", name: "4 AM" }, { value: "05", name: "5 AM" }, { value: "06", name: "6 AM" }, { value: "07", name: "7 AM" }];
export const MINUTES = ["00", "15", "20", "30", "40", "45"];
export var phone = new Audio('/phone.mp3');
export var callWait = new Audio('/wait.mp3');
export const TIMESREPEAT = TR_ARRAY;
export const REPEATS = [{ "value": "none", "name": "Does not repeat" }, { "value": "day", "name": "Daily" }, { "value": "week", "name": "Weekly" }, { "value": "month", "name": "Monthly" }];
export const TIMEZONES = { "index": ["Africa", "America", "Antarctica", "Atlantic", "Australia", "Europe", "Indian", "Pacific"], "names": { "Africa": ["Abidjan", "Asmera", "Blantyre", "Ceuta", "Douala", "Johannesburg", "Kinshasa", "Lubumbashi", "Mbabane", "Niamey", "Timbuktu", "Accra", "Bamako", "Brazzaville", "Conakry", "El_Aaiun", "Juba", "Lagos", "Lusaka", "Mogadishu", "Nouakchott", "Tripoli", "Addis_Ababa", "Bangui", "Bujumbura", "Dakar", "Freetown", "Kampala", "Libreville", "Malabo", "Monrovia", "Ouagadougou", "Tunis", "Algiers", "Banjul", "Cairo", "Dar_es_Salaam", "Gaborone", "Khartoum", "Lome", "Maputo", "Nairobi", "Porto-Novo", "Windhoek", "Asmara", "Bissau", "Casablanca", "Djibouti", "Harare", "Kigali", "Luanda", "Maseru", "Ndjamena", "Sao_Tome"], "America": ["Adak", "Antigua", "Argentina/Catamarca", "Argentina/Jujuy", "Argentina/Rio_Gallegos", "Argentina/San_Luis", "Aruba", "Atka", "Barbados", "Blanc-Sablon", "Boise", "Campo_Grande", "Catamarca", "Chicago", "Cordoba", "Cuiaba", "Dawson", "Detroit", "Eirunepe", "Fort_Wayne", "Godthab", "Grenada", "Guayaquil", "Havana", "Indiana/Knox", "Indiana/Tell_City", "Indiana/Winamac", "Iqaluit", "Juneau", "Knox_IN", "Lima", "Lower_Princes", "Manaus", "Matamoros", "Menominee", "Mexico_City", "Monterrey", "Montserrat", "Nipigon", "North_Dakota/Beulah", "Ojinaga", "Paramaribo", "Port_of_Spain", "Puerto_Rico", "Recife", "Rio_Branco", "Santarem", "Sao_Paulo", "Sitka", "St_Kitts", "St_Vincent", "Thule", "Toronto", "Virgin", "Yakutat", "Anchorage", "Araguaina", "Argentina/ComodRivadavia", "Argentina/La_Rioja", "Argentina/Salta", "Argentina/Tucuman", "Asuncion", "Bahia", "Belem", "Boa_Vista", "Buenos_Aires", "Cancun", "Cayenne", "Chihuahua", "Costa_Rica", "Curacao", "Dawson_Creek", "Dominica", "El_Salvador", "Fortaleza", "Goose_Bay", "Guadeloupe", "Guyana", "Hermosillo", "Indiana/Marengo", "Indiana/Vevay", "Indianapolis", "Jamaica", "Kentucky/Louisville", "Kralendijk", "Los_Angeles", "Maceio", "Marigot", "Mazatlan", "Merida", "Miquelon", "Montevideo", "Nassau", "Nome", "North_Dakota/Center", "Panama", "Phoenix", "Porto_Acre", "Rainy_River", "Regina", "Rosario", "Santiago", "Scoresbysund", "St_Barthelemy", "St_Lucia", "Swift_Current", "Thunder_Bay", "Tortola", "Whitehorse", "Yellowknife", "Anguilla", "Argentina/Buenos_Aires", "Argentina/Cordoba", "Argentina/Mendoza", "Argentina/San_Juan", "Argentina/Ushuaia", "Atikokan", "Bahia_Banderas", "Belize", "Bogota", "Cambridge_Bay", "Caracas", "Cayman", "Coral_Harbour", "Creston", "Danmarkshavn", "Denver", "Edmonton", "Ensenada", "Glace_Bay", "Grand_Turk", "Guatemala", "Halifax", "Indiana/Indianapolis", "Indiana/Petersburg", "Indiana/Vincennes", "Inuvik", "Jujuy", "Kentucky/Monticello", "La_Paz", "Louisville", "Managua", "Martinique", "Mendoza", "Metlakatla", "Moncton", "Montreal", "New_York", "Noronha", "North_Dakota/New_Salem", "Pangnirtung", "Port-au-Prince", "Porto_Velho", "Rankin_Inlet", "Resolute", "Santa_Isabel", "Santo_Domingo", "Shiprock", "St_Johns", "St_Thomas", "Tegucigalpa", "Tijuana", "Vancouver", "Winnipeg"], "Antarctica": ["Casey", "McMurdo", "Vostok", "Davis", "Palmer", "DumontDUrville", "Rothera", "Macquarie", "South_Pole", "Mawson", "Syowa"], "Asia": ["Aden", "Aqtobe", "Baku", "Calcutta", "Dacca", "Dushanbe", "Hong_Kong", "Jayapura", "Kashgar", "Krasnoyarsk", "Macau", "Nicosia", "Phnom_Penh", "Rangoon", "Seoul", "Tbilisi", "Tokyo", "Ust-Nera", "Yerevan", "Almaty", "Ashgabat", "Bangkok", "Choibalsan", "Damascus", "Gaza", "Hovd", "Jerusalem", "Kathmandu", "Kuala_Lumpur", "Magadan", "Novokuznetsk", "Pontianak", "Riyadh", "Shanghai", "Tehran", "Ujung_Pandang", "Vientiane", "Amman", "Ashkhabad", "Beirut", "Chongqing", "Dhaka", "Harbin", "Irkutsk", "Kabul", "Katmandu", "Kuching", "Makassar", "Novosibirsk", "Pyongyang", "Saigon", "Singapore", "Tel_Aviv", "Ulaanbaatar", "Vladivostok", "Anadyr", "Baghdad", "Bishkek", "Chungking", "Dili", "Hebron", "Istanbul", "Kamchatka", "Khandyga", "Kuwait", "Manila", "Omsk", "Qatar", "Sakhalin", "Taipei", "Thimbu", "Ulan_Bator", "Yakutsk", "Aqtau", "Bahrain", "Brunei", "Colombo", "Dubai", "Ho_Chi_Minh", "Jakarta", "Karachi", "Kolkata", "Macao", "Muscat", "Oral", "Qyzylorda", "Samarkand", "Tashkent", "Thimphu", "Urumqi", "Yekaterinburg"], "Atlantic": ["Azores", "Faroe", "St_Helena", "Bermuda", "Jan_Mayen", "Stanley", "Canary", "Madeira", "Cape_Verde", "Reykjavik", "Faeroe", "South_Georgia"], "Australia": ["ACT", "Currie", "Lindeman", "Perth", "Victoria", "Adelaide", "Darwin", "Lord_Howe", "Queensland", "West", "Brisbane", "Eucla", "Melbourne", "South", "Yancowinna", "Broken_Hill", "Hobart", "North", "Sydney", "Canberra", "LHI", "NSW", "Tasmania"], "Europe": ["Amsterdam", "Berlin", "Busingen", "Guernsey", "Kaliningrad", "Luxembourg", "Monaco", "Podgorica", "San_Marino", "Stockholm", "Vaduz", "Warsaw", "Andorra", "Bratislava", "Chisinau", "Helsinki", "Kiev", "Madrid", "Moscow", "Prague", "Sarajevo", "Tallinn", "Vatican", "Zagreb", "Athens", "Brussels", "Copenhagen", "Isle_of_Man", "Lisbon", "Malta", "Nicosia", "Riga", "Simferopol", "Tirane", "Vienna", "Zaporozhye", "Belfast", "Bucharest", "Dublin", "Istanbul", "Ljubljana", "Mariehamn", "Oslo", "Rome", "Skopje", "Tiraspol", "Vilnius", "Zurich", "Belgrade", "Budapest", "Gibraltar", "Jersey", "London", "Minsk", "Paris", "Samara", "Sofia", "Uzhgorod", "Volgograd"], "Indian": ["Antananarivo", "Kerguelen", "Reunion", "Chagos", "Mahe", "Christmas", "Maldives", "Cocos", "Mauritius", "Comoro", "Mayotte"], "Pacific": ["Apia", "Efate", "Galapagos", "Johnston", "Marquesas", "Noumea", "Ponape", "Tahiti", "Wallis", "Auckland", "Enderbury", "Gambier", "Kiritimati", "Midway", "Port_Moresby", "Tarawa", "Yap", "Chatham", "Fakaofo", "Guadalcanal", "Kosrae", "Nauru", "Palau", "Rarotonga", "Tongatapu", "Chuuk", "Fiji", "Guam", "Kwajalein", "Niue", "Pitcairn", "Saipan", "Truk", "Easter", "Funafuti", "Honolulu", "Majuro", "Norfolk", "Pohnpei", "Samoa", "Wake"] } };
export const COLORS = [{ color: "#F44336", name: "Red" }, { color: "#E91E63", name: "Pink" }, { color: "#9C27B0", name: "Purple" }, { color: "#673AB7", name: "Deep Purple" }, { color: "#3F51B5", name: "Indigo" }, { color: "#2196F3", name: "Blue" }, { color: "#03A9F4", name: "Light Blue" }, { color: "#00BCD4", name: "Cyan" }, { color: "#009688", name: "Teal" }, { color: "#4CAF50", name: "Green" }, { color: "#8BC34A", name: "Light Green" }, { color: "#CDDC39", name: "Lime" }, { color: "#FFC107", name: "Amber" }, { color: "#FF9800", name: "Orange" }, { color: "#FF5722", name: "Deep Orange" }, { color: "#795548", name: "Brown" }];
export const DURATION = [{ value: 15, name: "15 mins" }, { value: 20, name: "20 mins" }, { value: 30, name: "30 mins" }, { value: 40, name: "40 mins" }, { value: 45, name: "45 mins" }, { value: 60, name: "1 hour" }, { value: 90, name: "1.5 hours" }, { value: 120, name: "2 hours" }];
export const RESET_APPOINTMENT = { item: { timestamp_start: 0, timestamp_end: 0, client_id: '', provider_id: '', practice_id: '', notes_general: '', notes_client: '', notes_provider: '', time: '08:00', date: '', repeat: 'none', times: '', duration: 30, color: '', type: '', minutes: '00', hours: '08' } };
export const FILE_IMAGES = "https://firebasestorage.googleapis.com/v0/b/jennifer-anne-cafe.appspot.com/o/"

export const RESET_ACCOUNT = { item: { name: '', password: '',email:'',role:'store_admin',permission:{staff:false,report:true,ticket:false,user:false,group:false,room:false}} };
export const RESET_GROUP = { item: { name: '',store_id:'' } };
export const RESET_DISTRICT = { item: { name: '', location: '',order:0,city_id:"" } };
export const RESET_CITY = { item: { name: '', location: '',order:0 } };
export const RESET_STORE = { item: { name: '', address: '', phone: '', location: '',district_id : '',admin_id:'',order:0,ticket:"",default_group:"",verified:false } };
export const RESET_USER = { item: { name: '', password: '',username:"", store_id: '',guest:false,role:'user' } };
export const RESET_STAFF = { item: { name: '', number: '', store_id: '',group_id:[],avatar:"",status:0,images:[], store_id2: '',group_id2:[] },open: false,avatar:null,avatar_preview:"",images:[],images_preview:[],images_deleted:[],description:""};
export const RESET_ROOM = { item: { name: '',store_id:"",status:0,order:0 } };
export const RESET_TICKET = { item: { name: '',store_id:"",price:"",time:"",staff:1,group_id:"",order:0 } };
export const RESET_CODE = { item: { name: '',note:'',before:'20:00',price:0,codes:{},qty:0,prefix:'' } };
export const RESET_PROMOTE = { item: { name: '',note:"",store_id:"",repeat:0,status:0,start_date:moment().format('YYYY-MM-DD'),start_time:"09:00",end_time:"11:00",codes:{} } };
export const answerTimeList = [{label:"10s",value:10}
,{label:"6s",value:6}
,{label:"5s",value:5}
,{label:"4s",value:4}
,{label:"3s",value:3}
,{label:"2s",value:2}
]
export const showTimeList = [{label:"20 sec",value:20},{label:"15 sec",value:15},{label:"10 sec",value:10},
{label:"6 sec",value:6}
,{label:"5 sec",value:5}
,{label:"4 sec",value:4}
,{label:"3 sec",value:3}
,{label:"2 sec",value:2}
]
export const qCountList = [
  {label:"5",value:5},{label:"10",value:10},{label:"15",value:15}
,{label:"20",value:20}
,{label:"30",value:30}
]
export const maxNumberList = [{label:"10",value:10}
,{label:"100",value:100}

]
export const digitsList = [{label:"1",value:1}
,{label:"2",value:2}
,{label:"3",value:3}

]
export const CompTypeList = [{label:"Nhìn Tính",value:"see"}
,{label:"Nghe Tính",value:"listen"}
,{label:"Online",value:"online"}

]
export const YesNoList = [{label:"No",value:0}
,{label:"Yes",value:1}]
export const LBFormulaList = [0,4,3,2,1,-4,-3,-2,-1,9.1,9.2,8.1,8.2,7.1,7.2,6.1,6.2,5.1,4.1,3.1,2.1,1.1,-9.1,-9.2,-8.1,-8.2,-7.1,-7.2,-6.1,-6.2,-5.1,-4.1,-3.1,-2.1,-1.1];
export const LBFormulaList2 = [0,4,3,2,1,-4,-3,-2,-1,1.1,2.1,3.1,4.1,5.1,6.1,6.2,7.1,7.2,8.1,8.2,9.1,9.2,-1.1,-2.1,-3.1,-4.1,-5.1,-6.1,-6.2,-7.1,-7.2,-8.1,-8.2,-9.1,-9.2];
export const typeList = [{label:"Finger",value:'image',fvalue:-1}
,{label:"No Formula",value:'LB_0',fvalue:0}
,{label:"LB+4",value:'LB_4',fvalue:4}
,{label:"LB+3",value:'LB_3',fvalue:3}
,{label:"LB+2",value:'LB_2',fvalue:2}
,{label:"LB+1",value:'LB_1',fvalue:1}
,{label:"LB-4",value:'LB_-4',fvalue:-4}
,{label:"LB-3",value:'LB_-3',fvalue:-3}
,{label:"LB-2",value:'LB_-2',fvalue:-2}
,{label:"LB-1",value:'LB_-1',fvalue:-1}
,{label:"BB+9",value:'BB_9.1',fvalue:9.1}
,{label:"L&B+9",value:'L&B_9.2',fvalue:9.2}
,{label:"BB+8",value:'BB_8.1',fvalue:8.1}
,{label:"L&B+8",value:'L&B_8.2',fvalue:8.2}
,{label:"BB+7",value:'BB_7.1',fvalue:7.1}
,{label:"L&B+7",value:'L&B_7.2',fvalue:7.2}
,{label:"BB+6",value:'BB_6.1',fvalue:6.1}
,{label:"L&B+6",value:'L&B_6.2',fvalue:6.2}
,{label:"BB+5",value:'BB_5.1',fvalue:5.1}
,{label:"BB+4",value:'BB_4.1',fvalue:4.1}
,{label:"BB+3",value:'BB_3.1',fvalue:3.1}
,{label:"BB+2",value:'BB_2.1',fvalue:2.1}
,{label:"BB+1",value:'BB_1.1',fvalue:1.1}
,{label:"BB-9",value:'BB_-9.1',fvalue:-9.1}
,{label:"L&B-9",value:'L&B_-9.2',fvalue:-9.2}
,{label:"BB-8",value:'BB_-8.1',fvalue:-8.1}
,{label:"L&B-8",value:'L&B_-8.2',fvalue:-8.2}
,{label:"BB-7",value:'BB_-7.1',fvalue:-7.1}
,{label:"L&B-7",value:'L&B_-7.2',fvalue:-7.2}
,{label:"BB-6",value:'BB_-6.1',fvalue:-6.1}
,{label:"L&B-6",value:'L&B_-6.2',fvalue:-6.2}
,{label:"BB-5",value:'BB_-5.1',fvalue:-5.1}
,{label:"BB-4",value:'BB_-4.1',fvalue:-4.1}
,{label:"BB-3",value:'BB_-3.1',fvalue:-3.1}
,{label:"BB-2",value:'BB_-2.1',fvalue:-2.1}
,{label:"BB-1",value:'BB_-1.1',fvalue:-1.1}
,{label:"Soroban",value:'soroban',fvalue:-1}
,{label:"Multiple",value:'multiple',fvalue:-1}
,{label:"Divide",value:'divide',fvalue:-1}
]
export const typeCatList = [{label:"Flash Card",value:'image',childs:[{label:"Finger",value:'image'},{label:"Soroban",value:'soroban'}]},
{label:"+&-",value:'lb',childs:[
  {label:"No Formula",value:'LB_0'}
  ,{label:"LB+4",value:'LB_4'}
  ,{label:"LB+3",value:'LB_3'}
  ,{label:"LB+2",value:'LB_2'}
  ,{label:"LB+1",value:'LB_1'}
  ,{label:"LB-4",value:'LB_-4'}
  ,{label:"LB-3",value:'LB_-3'}
  ,{label:"LB-2",value:'LB_-2'}
  ,{label:"LB-1",value:'LB_-1'}
  ,{label:"BB+9",value:'BB_9.1'}
  ,{label:"L&B+9",value:'L&B_9.2'}
  ,{label:"BB+8",value:'BB_8.1'}
  ,{label:"L&B+8",value:'L&B_8.2'}
  ,{label:"BB+7",value:'BB_7.1'}
  ,{label:"L&B+7",value:'L&B_7.2'}
  ,{label:"BB+6",value:'BB_6.1'}
  ,{label:"L&B+6",value:'L&B_6.2'}
  ,{label:"BB+5",value:'BB_5.1'}
  ,{label:"BB+4",value:'BB_4.1'}
  ,{label:"BB+3",value:'BB_3.1'}
  ,{label:"BB+2",value:'BB_2.1'}
  ,{label:"BB+1",value:'BB_1.1'}
  ,{label:"BB-9",value:'BB_-9.1'}
  ,{label:"L&B-9",value:'L&B_-9.2'}
  ,{label:"BB-8",value:'BB_-8.1'}
  ,{label:"L&B-8",value:'L&B_-8.2'}
  ,{label:"BB-7",value:'BB_-7.1'}
  ,{label:"L&B-7",value:'L&B_-7.2'}
  ,{label:"BB-6",value:'BB_-6.1'}
  ,{label:"L&B-6",value:'L&B_-6.2'}
  ,{label:"BB-5",value:'BB_-5.1'}
  ,{label:"BB-4",value:'BB_-4.1'}
  ,{label:"BB-3",value:'BB_-3.1'}
  ,{label:"BB-2",value:'BB_-2.1'}
  ,{label:"BB-1",value:'BB_-1.1'}
]},
{label:"Multiple",value:'multiple',childs:[{label:"Multiple",value:'multiple'}]},
{label:"Divide",value:'divide',childs:[{label:"Divide",value:'divide'}]}


]
export const AGROUP = {
  '[BS]Finger':{symbol:'circle',color:'blue'},
  '[BS]Basic':{symbol:'diamond',color:'blue'},
  '[FG]Finger':{symbol:'circle',color:'gold'},
  '[FG]Basic':{symbol:'diamond',color:'gold'},
  '[FG]LB+':{symbol:'plus',color:'gold'},
  '[FG]LB-':{symbol:'minus',color:'gold'},
  '[FG]BB+':{symbol:'square',color:'gold'},
  '[FG]BB-':{symbol:'star',color:'gold'},
  '[FG]+/-':{symbol:'triangleDown',color:'gold'},
  '[SP1]Soroban':{symbol:'circle',color:'green'},
  '[SP1]Basic':{symbol:'diamond',color:'green'},
  '[SP1]LB+':{symbol:'plus',color:'green'},
  '[SP1]LB-':{symbol:'minus',color:'green'},
  '[SP1]BB+':{symbol:'square',color:'green'},
  '[SP1]BB-':{symbol:'star',color:'green'},
  '[SP1]+/-':{symbol:'triangleDown',color:'green'},
  '[SP2]+/-':{symbol:'circle',color:'darkgreen'},
  '[SP2]Multi':{symbol:'diamond',color:'darkgreen'},
  '[SP3]+/-':{symbol:'plus',color:'darkgreen'},
  '[SP3]Multi':{symbol:'square',color:'darkgreen'},
  '[SP4]+/-':{symbol:'star',color:'darkgreen'},
  '[SP4]Multi':{symbol:'triangleUp',color:'darkgreen'},
  '[SP4]Divide':{symbol:'triangleDown',color:'darkgreen'},

};
export const DWIDTH = 640;
export const styles = theme => ({
  root: {
      flexGrow: 1,
      zIndex: 1,
      backgroundImage: "url('assets/web/bg_new_2.jpg')",
      backgroundPosition: "center center",
      backgroundAttachment: "fixed",
      WebkitBackgroundSize: "cover",
      backgroundSize: "cover",
      overflow: 'hidden',
      position: 'absolute',
      display: 'table',
      height: '100%',
      width: '100%',
      color:'#A4C944'
  },
  middle: {
      display: 'table-cell',
      verticalAlign: 'middle'
  },
  square: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: DWIDTH,

      background:'none'
  },
  textField: {
      minWidth: 200,

  },container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  }
});
export const styles2 = theme => ({
  root: {
      flexGrow: 1,
      zIndex: 1,
      backgroundImage: "url('assets/comp/bg_comp.png')",
      backgroundPosition: "center center",
      backgroundAttachment: "fixed",
      WebkitBackgroundSize: "cover",
      backgroundSize: "cover",
      overflow: 'hidden',
      position: 'absolute',
      display: 'table',
      height: '100%',
      width: '100%',
      color:'#A4C944',
      fontFamily:"MYRE"
  },
  middle: {
      display: 'table-cell',
      verticalAlign: 'middle'
  },
  square: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: "1170px",

      background:'none'
  },
  textField: {
      minWidth: 200,

  },container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  }
});

export function calSize(x,oWidth,width)
{
  return (width)*(x/oWidth);
}

export const SERVER = "https://us-central1-vnsuperbrain.cloudfunctions.net/";
export const SERVERTEST = "http://localhost:5000/vnsuperbrain/us-central1/";
export const API_USER_CHECKLOGIN = SERVER+'User_CheckLogin';
export const API_USER_ADDGUEST = SERVER+'User_AddGuest';
export const API_USER_SENDFORGOT = SERVER+'User_SendForgot';
export const API_USER_CHANGEPASS = SERVER+'User_ChangePass';
export const API_STUDENT_MARATHON = SERVER+'Student_Marathon';
export const API_STUDENT_MARATHONRESULT = SERVER+'Student_MarathonResult';
export const API_STUDENT_POSTRESULT = SERVER+'Student_PostResult';
export const API_STUDENT_POSTRESULTADVANCE = SERVER+'Student_PostResultAdvance';
export const API_STUDENT_POSTRESULTCHALLENGE = SERVER+'Student_PostResultChallenge';
export const API_STUDENT_EXCHANGEPOINT = SERVER+'Student_ExchangePoint';
export const API_ADMIN_SYNCHOLIDAY = SERVER+'syncHolidayData';
export const API_ADMIN_SYNCALLDATA = SERVER+'syncAllData';
export const API_MARATHON_CLEARDATA = SERVER+'MarathonClearData';
export const API_TESTAPI = SERVER+'testAPI';
export const API_FETCHURL = SERVER+'fetchURL';
export const API_COMP_POSTRESULT = SERVER+'Comp_PostResult';
export const API_COMP_FETCHLIST = SERVER+'Comp_FetchList';
export const API_GETTIME = SERVER+'getTime';
export async function loadJSONData(url) {
  try {
         const response = await  fetch(url);
         const responseJson = await response.json();
         return responseJson;
     } catch(error){
          console.error(error);
          return null;
     }
}
export async function postFormData(url,data) {


var formBody = [];
for (var property in data) {
  var encodedKey = encodeURIComponent(property);
  var encodedValue = encodeURIComponent(data[property]);
  formBody.push(encodedKey + "=" + encodedValue);
}
formBody = formBody.join("&");
try {
const response = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  body: formBody
});
const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
export async function postFormData2(url,data) {


  let formData = new FormData();
  // Assume "photo" is the name of the form field the server expects

for (var property in data) {

  formData.append(property, data[property]);
}

try {
const response = await fetch(url, {
  method: 'POST',
  body: formData,
  header: {
    'content-type': 'multipart/form-data',
  }
});
const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
export function slugify(name)
{
    if(!name||name.trim.lenght==0)
    return '';
    var slug;
     slug = name.toLowerCase();

     //Đổi ký tự có dấu thành không dấu
     slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
     slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
     slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
     slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
     slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
     slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
     slug = slug.replace(/đ/gi, 'd');
     //Xóa các ký tự đặt biệt
     slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
     //Đổi khoảng trắng thành ký tự gạch ngang
     slug = slug.replace(/ /gi, "-");
     //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
     //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
     slug = slug.replace(/\-\-\-\-\-/gi, '-');
     slug = slug.replace(/\-\-\-\-/gi, '-');
     slug = slug.replace(/\-\-\-/gi, '-');
     slug = slug.replace(/\-\-/gi, '-');
     //Xóa các ký tự gạch ngang ở đầu và cuối
     slug = '@' + slug + '@';
     slug = slug.replace(/\@\-|\-\@|\@/gi, '');
     return slug;
}
export function s2ab(s) {
var buf = new ArrayBuffer(s.length);
var view = new Uint8Array(buf);
for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
return buf;
}
function clamp_range(range) {
	if(range.e.r >= (1<<20)) range.e.r = (1<<20)-1;
	if(range.e.c >= (1<<14)) range.e.c = (1<<14)-1;
	return range;
}

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;

export function insert_rows(ws, start_row, nrows, opts) {
	if(!ws) throw new Error("operation expects a worksheet");
	var dense = Array.isArray(ws);
	if(!nrows) nrows = 1;
	if(!start_row) start_row = 0;
	if(!opts) opts = {};

	/* extract original range */
	var range = XLSX.utils.decode_range(ws["!ref"]);
	var R = 0, C = 0;

	var formula_cb = function($0, $1, $2, $3, $4, $5) {
		var _R = XLSX.utils.decode_row($5), _C = XLSX.utils.decode_col($3);
		if(!opts.fill ? (_R >= start_row) : (R >= start_row)) _R += nrows;
		return $1+($2=="$" ? $2+$3 : XLSX.utils.encode_col(_C))+($4=="$" ? $4+$5 : XLSX.utils.encode_row(_R));
	};

	var addr, naddr, newcell;
	/* move cells and update formulae */
	if(dense) {
		/* cells after the insert */
		for(R = range.e.r; R >= start_row; --R) {
			if(ws[R]) ws[R].forEach(function(cell) { if(cell.f) cell.f = cell.f.replace(crefregex, formula_cb); });
			ws[R+nrows] = ws[R];
		}

		/* TODO: dense mode; newly created space */
		for(R = start_row; R < start_row + nrows; ++R) ws[R] = [];

		/* cells before insert */
		for(R = 0; R < start_row; ++R) {
			if(ws[R]) ws[R].forEach(function(cell) { if(cell.f) cell.f = cell.f.replace(crefregex, formula_cb); });
		}
		range.e.r += nrows;
	} else {
		/* cells after the insert */
		for(R = range.e.r; R >= start_row; --R) {
			for(C = range.s.c; C <= range.e.c; ++C) {
				addr = XLSX.utils.encode_cell({r:R, c:C});
				naddr = XLSX.utils.encode_cell({r:R+nrows, c:C});
				if(!ws[addr]) { delete ws[naddr]; continue; }
				if(opts.fill && (ws[addr].s || ws[addr].f)) {
					newcell = {};
					if(ws[addr].f) { newcell.f = ws[addr].f; newcell.t = ws[addr].t; }
					else { newcell.t = "z"; }
				}
				if(ws[addr].f) ws[addr].f = ws[addr].f.replace(crefregex, formula_cb);
				ws[naddr] = ws[addr];
				if(opts.fill) { ws[addr] = newcell; console.log(ws[addr], newcell); }
				if(range.e.r < R + nrows) range.e.r = R + nrows;
			}
		}

		/* newly created space */
		if(!opts.fill) for(R = start_row; R < start_row + nrows; ++R) {
			for(C = range.s.c; C <= range.e.c; ++C) {
				addr = XLSX.utils.encode_cell({r:R, c:C});
				delete ws[addr];
			}
		}

		/* cells before insert */
		for(R = 0; R < start_row; ++R) {
			for(C = range.s.c; C <= range.e.c; ++C) {
				addr = XLSX.utils.encode_cell({r:R, c:C});
				if(ws[addr] && ws[addr].f) ws[addr].f = ws[addr].f.replace(crefregex, formula_cb);
			}
		}
	}

	/* write new range */
	ws["!ref"] = XLSX.utils.encode_range(clamp_range(range));

	/* merge cells */
	if(ws["!merges"]) ws["!merges"].forEach(function(merge, idx) {
		var mergerange;
		switch(typeof merge) {
			case 'string': mergerange = XLSX.utils.decode_range(merge); break;
			case 'object': mergerange = merge; break;
			default: throw new Error("Unexpected merge ref " + merge);
		}
		if(mergerange.s.r >= start_row) mergerange.s.r += nrows;
		if(mergerange.e.r >= start_row) mergerange.e.r += nrows;
		clamp_range(mergerange);
		ws["!merges"][idx] = mergerange;
	});

	/* rows */
	var rowload = [start_row, 0];
	for(R = 0; R < nrows; ++R) rowload.push(void 0);
	if(ws["!rows"]) ws["!rows"].splice.apply(ws["!rows"], rowload);
}
